import type { EnumMultiMerchantResourceRoleApi } from '@ingenico/api-sdk-provisioning-private';
import { enumMultiMerchantResourceRole } from '@ingenico/api-sdk-provisioning-private';
import { LogicalDeviceSyncConfigurationModalVariant } from '@ingenico/type-mfe-contracts/domains';
import type {
  SyncConfigurationTargetDetails,
  SyncConfigurationWarningContent,
} from './LogicalDeviceSyncConfigurationModal.model';

export function isGroupedMultiMerchantDevice(role: EnumMultiMerchantResourceRoleApi | undefined): boolean {
  return role === enumMultiMerchantResourceRole.PRIMARY || role === enumMultiMerchantResourceRole.SECONDARY;
}

export function isGroupedMultiMerchantSyncTarget(
  logicalDeviceId: string | undefined,
  targetDetails: SyncConfigurationTargetDetails | null | undefined,
): boolean {
  if (!logicalDeviceId || targetDetails?.logicalDeviceId !== logicalDeviceId) {
    return false;
  }

  return isGroupedMultiMerchantDevice(targetDetails.details.multiMerchant?.logicalDeviceRole);
}

export function getSyncConfigurationWarningContent({
  isConfigProfileOrderingEnabled,
  isGroupedDevice,
  variant,
}: {
  readonly isConfigProfileOrderingEnabled: boolean;
  readonly isGroupedDevice: boolean;
  readonly variant: LogicalDeviceSyncConfigurationModalVariant;
}): SyncConfigurationWarningContent {
  if (isGroupedDevice) {
    return {
      titleKey: isConfigProfileOrderingEnabled
        ? 'syncConfigurationModal.warning.titleMultiMerchantWithDeploymentPriority'
        : 'syncConfigurationModal.warning.titleMultiMerchant',
      hasMessage: false,
    };
  }

  if (!isConfigProfileOrderingEnabled) {
    return { titleKey: 'syncConfigurationModal.warning.title_ff_off', hasMessage: true };
  }

  return {
    titleKey:
      variant === LogicalDeviceSyncConfigurationModalVariant.SingleDevice
        ? 'syncConfigurationModal.warning.titleSingleDevice'
        : 'syncConfigurationModal.warning.titleMultipleDevices',
    hasMessage: false,
  };
}
